import { render, staticRenderFns } from "./help.vue?vue&type=template&id=25ad6792&scoped=true"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./aside.scss?vue&type=style&index=0&id=25ad6792&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ad6792",
  null
  
)

export default component.exports